import { frontendURL } from '../../../helper/URLHelper';

const PainelView = () => import('./PainelView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/painel'),
    name: 'painel_index',
    component: PainelView,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
